import { render, staticRenderFns } from "./MspEditGara.vue?vue&type=template&id=ca94771c"
import script from "./MspEditGara.vue?vue&type=script&lang=js"
export * from "./MspEditGara.vue?vue&type=script&lang=js"
import style0 from "./MspEditGara.vue?vue&type=style&index=0&id=ca94771c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports